import React from 'react';
import { Icon, IconNameType } from 'components';

type FileTypeIconProps = {
  fileType: string;
};

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ fileType }) => {
  let type: IconNameType = 'antdFileImageFilled';
  if (fileType === 'application/pdf') type = 'antdFilePdfFilled';
  return <Icon type={type} />;
};

export default FileTypeIcon;
